<template>
  <div :style="{ width: `${width}px` }" class="dropdown-wrapper">
    <div class="outside" v-if="opened"></div>
    <div class="dropdown" :id="dropId">
      <a :style="{ width: `${width}px` }" class="btn p-0" @click="handleDrop">
        <slot name="btn" :opened="opened" :hover="hover" :value="data"></slot>
      </a>
      <div
        @mouseover="hover = true"
        @mouseleave="hover = false"
        :class="{ top: top, topEditCards: topEditCards }"
        class="drop-item-wrapper"
      >
        <div class="drop-item">
          <a
            v-for="(option, index) in options"
            :key="index"
            :class="{ active: data === option }"
            :style="{ width: `${width}px` }"
            @click="mark(option)"
            >{{ option.text }}</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      required: true,
    },
    dropId: {
      required: true,
    },
    value: {
      required: true,
    },
    width: {
      required: true,
    },
    top: {
      default: false,
    },
    topEditCards: {
      default: false,
    },
  },
  data() {
    return {
      data: {},
      opened: false,
      hover: false,
    }
  },
  watch: {
    data() {
      this.$emit('update', this.data)
    },
    value() {
      this.data = this.value
    },
  },
  methods: {
    mark(option) {
      this.data = option
      const dropItem = document.querySelector(`#${this.dropId}`)
      dropItem.children[1].classList.remove('active')
      this.opened = false
    },
    handleDrop() {
      const dropItem = document.querySelector(`#${this.dropId}`)
      dropItem.children[1].classList.toggle('active')
      this.opened = !this.opened
      this.outsideClick(dropItem, ['click'], () => {
        dropItem.children[1].classList.remove('active')
        this.opened = false
      })
    },
    outsideClick(element, events, callback) {
      const html = document.documentElement
      const outside = 'data-outside'
      if (!element.hasAttribute(outside)) {
        events.forEach(userEvent => {
          setTimeout(() => {
            html.addEventListener(userEvent, () => {
              if (!element.contains(event.target)) {
                element.removeAttribute(outside)
                events.forEach(userEvent => {
                  html.removeEventListener(userEvent, this.handleOutsideClick)
                })
                callback()
              }
            })
          })
        })
        element.setAttribute(outside, '')
      }
    },
  },
  created() {
    this.data = this.options[0]
  },
}
</script>
<style lang="scss" scoped>
.outside {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.dropdown {
  &:hover {
    .drop-item-wrapper {
      display: block;
    }
  }
}
.drop-item-wrapper {
  position: absolute;
  display: none;
  padding-top: 20px;
  &.top {
    padding-top: unset;
    padding-bottom: 20px;
    top: 260px;
    bottom: 20px;
  }
  &.topEditCards {
    padding-top: unset;
    padding-bottom: 20px;
    top: 178px;
    bottom: 20px;
  }
  &.active {
    display: block;
  }
}
.drop-item {
  background: #fff;
  max-height: 210px;
  overflow: auto;
  overflow-x: hidden;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  padding-bottom: 10px;
  padding-top: 10px;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
    height: 40px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #fff;
  }
  a {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 5px 10px;
    text-decoration: none;
    cursor: pointer;
    font-size: 16px;
    @include tipography(16);
    color: $gray-4;
    font-weight: 400;
    &:hover,
    &.active {
      color: $gray-2;
      font-weight: 500;
      background: $gray-light-5;
    }
    &::after {
      content: '';
      display: none;
      width: 4px;
      height: 4px;
      background: $gray-2;
      margin-left: 5px;
      border-radius: 50%;
    }
    &.active {
      &::after {
        display: block;
      }
    }
  }
}
</style>
